const initialState = {
  show: false,
  message: '',
  type: 'info', // 'info', 'success', 'warning', 'error'
  duration: 3000
};

const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_TOAST':
      return {
        show: true,
        message: action.payload.message,
        type: action.payload.type || 'info',
        duration: action.payload.duration || 3000,
        noSound: action.payload.noSound,
        noHideOnTurnEnd: action.payload.noHideOnTurnEnd,
        hintId: action.payload.hintId,
        icon: action.payload.icon,
      };
    case 'SHOW_TOAST_WAIT_OTHER_PLAYER_TURN':
      return {
        show: true,
        message: `Дождитесь окончания хода игрока ${action.payload.currentPlayer.name}`,
        type: 'warning',
        duration: 3000
      };
    case 'HIDE_TOAST':
      return {
        ...state,
        show: false
      };
    default:
      return state;
  }
};

export default toastReducer;
